<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 16 14"
  >
    <g transform="translate(0 0)">
      <path
        class="svg-primary"
        d="M8.735,18.391H2.727a.9.9,0,0,1-.791-.973V9.678A.9.9,0,0,1,2.727,8.7H13.175a.9.9,0,0,1,.791.973v1.269a.433.433,0,0,0,.41.454.444.444,0,0,0,.41-.454V9.678a1.788,1.788,0,0,0-1.627-1.9H10.318V6.838A.986.986,0,0,0,9.409,5.8H6.317a.986.986,0,0,0-.909,1.038v.941H2.727A1.788,1.788,0,0,0,1.1,9.678v7.739a1.788,1.788,0,0,0,1.627,1.9H8.75a.434.434,0,0,0,.41-.454A.45.45,0,0,0,8.735,18.391ZM6.244,6.855c0-.065.044-.13.073-.13H9.409c.029,0,.073.049.073.13v.925H6.244Z"
        transform="translate(-1.1 -5.8)"
      />
    </g>
    <g transform="translate(7.891 5.891)">
      <g transform="translate(0 0)">
        <path
          class="svg-primary"
          d="M20.255,16.2a4.055,4.055,0,1,0,4.055,4.055A4.057,4.057,0,0,0,20.255,16.2Zm0,7.534a3.479,3.479,0,1,1,3.479-3.479A3.481,3.481,0,0,1,20.255,23.734Z"
          transform="translate(-16.2 -16.2)"
        />
        <path
          class="svg-primary"
          d="M47.624,60.592a.335.335,0,0,1-.24-.1.352.352,0,0,1-.084-.228.328.328,0,0,1,.1-.228.334.334,0,0,1,.456,0,.328.328,0,0,1,.1.228.307.307,0,0,1-.1.228A.284.284,0,0,1,47.624,60.592Z"
          transform="translate(-43.569 -54.702)"
        />
        <path
          class="svg-primary"
          d="M47.624,37.051a.323.323,0,0,1-.324-.324v-1.7a.324.324,0,1,1,.648,0v1.7A.323.323,0,0,1,47.624,37.051Z"
          transform="translate(-43.569 -32.481)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>